module.exports = __webpack_public_path__ + "img/logo-as-banner-bg-shape_magenta.96ee7d1.svg";